module.exports = {
  "info@guarity.nl": true,
  "h.teker@live.nl": true,
};



// WEBPACK FOOTER //
// ./src/data/uber-admin-emails.js